<template>
    <div class="container container-float container-fixed container-header" :class="{'container-shadow': $root.isScrolled}">
      <div class="wrapper">
        <div class="container-float container-float-left">  
          <router-link tag="div" class="logo" :to="'/'"></router-link>
        </div>
        <div class="container-float container-float-right">
          <div>
            <a @click="$root.close()" class="close"></a>
          </div>
        </div>
        <div class="container container-small container-nopadding logotype">
            <span v-html="title"></span>
        </div>
      </div>
    </div>
</template>


<script>


export default {
  name: 'StaticHeader',
  props: ['title'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
